import Vue from 'vue'
import VueMeta from 'vue-meta'
import PortalVue from 'portal-vue'
import { App, plugin } from '@inertiajs/inertia-vue'
import { InertiaProgress } from '@inertiajs/progress/src'
import axios from 'axios'
import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-default.css'
import 'vue-select/dist/vue-select.css'
import 'leaflet/dist/leaflet.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import 'vue2-datepicker/index.css'
import { format } from '@/Utils/money'


Vue.config.productionTip = false
Vue.mixin({ methods: { route: window.route } })
Vue.use(plugin)
Vue.use(PortalVue)
Vue.use(VueMeta)
Vue.use(VueToast)

Vue.prototype.$axios = axios

InertiaProgress.init()

const el = document.getElementById('app')
Vue.mixin({
  methods: {
    formatValue: format,
  },
})
new Vue({
  metaInfo: {
    titleTemplate: title => (title ? `${title} - Visitor` : 'Visitor'),
  },
  render: h =>
    h(App, {
      props: {
        initialPage: JSON.parse(el.dataset.page),
        resolveComponent: name => require(`./Pages/${name}`).default,
      },
    }),
}).$mount(el)
